import batch_settings_mixin from './_mixin';

/**
 * 送料無料設定モーダル
 */
export default {
    name: 'modalBatchSettingsItem',
    template: '#modal_batch_settings_item_template',
    data() {
        // 設定データ以外のパラメータを保持しない
        return {
            all_delivery: '0',
            specific_price_delivery: '0',
            free_shipping_price: null
        };
    },
    mixins: [ batch_settings_mixin ],
};
